import React, {Component} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import classnames from 'classnames';
import {ThemeContext, InfiniteScroller, Search} from '../../common';
import TreasureChestItem from '../TreasureChestItem';
import {noDataToDisplay} from '../../../configs/messages';

export default class TreasureChestContent extends Component {
  static propTypes = {
    leaders: PropTypes.shape({
      currentPlayer: PropTypes.shape({
        points: PropTypes.number,
      }).isRequired,
    }).isRequired,
    isPanel: PropTypes.bool,
    treasures: PropTypes.shape({
      hasMore: PropTypes.bool.isRequired,
      list: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    }).isRequired,
    onTreasuresQuery: PropTypes.func.isRequired,
    onTreasureSelect: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isPanel: false,
  };

  componentDidMount() {
    this.props.onTreasuresQuery({resetPage: true});
  }

  onSearch = (query) => {
    this.props.onTreasuresQuery({resetPage: true, query});
  };

  renderItem = item => (<TreasureChestItem
    {...item}
    key={item.id}
    onTreasureSelect={() => this.props.onTreasureSelect(item)}
  />);

  renderSearch = () => (
    <Search
      className="treasure-search"
      onSearch={this.onSearch}
      placeholder="search treasures"
    />
  );

  renderEmpty = () => (
    <ThemeContext.Consumer>
      {(theme) => {
        const styles = {color: theme.secondaryColor};

        return (
          <div className="treasure-chest-panel__empty-wrapper text-center">
            <h4 style={styles}>
              {noDataToDisplay}
            </h4>
          </div>
        );
      }}
    </ThemeContext.Consumer>
  );

  renderItems = list => (
    isEmpty(list) ? this.renderEmpty() : list.map(this.renderItem)
  );

  render() {
    const {
      onTreasuresQuery, isPanel,
      treasures: {list, hasMore},
    } = this.props;

    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const styles = {color: theme.primaryColor};

          return (
            <div
              className={classnames(
                'panel__content',
                {'treasure-list-like-panel': isPanel}
              )}
            >
              {this.renderSearch()}
              <div className="treasure-list custom-overflow" style={styles}>
                <InfiniteScroller
                  loadMore={onTreasuresQuery}
                  hasMore={hasMore && !(isEmpty(list))}
                >
                  {this.renderItems(list)}
                </InfiniteScroller>
              </div>
            </div>
          );
        }}
      </ThemeContext.Consumer>
    );
  }
}
